module.exports = __webpack_public_path__ + "assets/loading-color.e50d3468.svg";